import React from 'react';
const UserContext = React.createContext({
    ineligibility_flag: null,
    authenticated: false,
});
export default UserContext;
//# sourceMappingURL=user.js.map